import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { CreditCardPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/_shared/entities/PaymentMethodDetail/CreditCardPaymentMethodDetailEntity';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { CreditLinePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/_shared/entities/PaymentMethodDetail/CreditLinePaymentMethodDetailEntity';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { SinglePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/SinglePayment/_shared/entities/PaymentMethodDetail/SinglePaymentMethodDetailEntity';

const PaymentMethodDetailEntities = [
  BnplPaymentMethodDetailEntity,
  CreditLinePaymentMethodDetailEntity,
  LoanPaymentMethodDetailEntity,
  CardOnboardingPaymentMethodDetailEntity,
  SinglePaymentMethodDetailEntity,
  CreditCardPaymentMethodDetailEntity,
] as const;

export class PaymentMethodDetailFactory {
  static create(paymentMethodType: PaymentMethodType) {
    for (const PaymentMethodDetailEntity of PaymentMethodDetailEntities) {
      if (PaymentMethodDetailEntity.allowed.includes(paymentMethodType)) {
        return PaymentMethodDetailEntity;
      }
    }
    throw new Error(`Payment method type ${paymentMethodType} not found`);
  }
}
